module.exports = __webpack_public_path__ + "img/netherlands.31c81ed2.svg";